module.exports = __webpack_public_path__ + "img/img22.8d6f1871.svg";